import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../shared/services/auth.service';
import { CommonService } from '../../shared/services/common.service';
import { StorageService } from '../../shared/services/storage.service';
import { ActivatedRoute } from '@angular/router';
import { from } from 'rxjs';
@Component({
  selector: 'app-autologin',
  templateUrl: './autologin.component.html',
  styleUrl: './autologin.component.scss',
})
export class AutologinComponent {
  form!: FormGroup;

  submitted = false;

  passwordType: string = 'password';
  eye: string = 'bi-eye';
  pwdShow = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private commonService: CommonService,
    private storage: StorageService,
    private route: ActivatedRoute, // private socialAuthService: SocialAuthService
  ) {}
  token: any = null;
  to: any = null;
  from: any = null;
  ngOnInit(): void {
    try {
      this.form = this.fb.group({
        email: ['', [Validators.required]],
        password: ['', [Validators.required]],
        signin_type: ['email'],
      });

      this.route.queryParamMap.subscribe((params) => {
        this.token = params.get('token'); // Extract the "token" parameter
        this.to = params.get('to'); // Extract the "to" parameter
        this.from = params.get('from'); // Extract the "from" parameter
        if (this.from) {
          this.storage.setItem('from', this.from); // Store 'from' in local storage
          // Break into base URL and last segment
          let decodedFrom = decodeURIComponent(this.from);
          // Remove trailing slash if present
          if (decodedFrom.endsWith('/')) {
            decodedFrom = decodedFrom.slice(0, -1);
          }
          // Find last segment
          let lastSegment = decodedFrom.split('/').pop() || '';
          // Find base URL (everything before last segment)
          let baseUrl = decodedFrom.substring(0, decodedFrom.lastIndexOf('/'));
          this.storage.setItem('from_base', baseUrl);
          this.storage.setItem('from_last', lastSegment);
        } else {
          this.storage.removeItem('from'); // Remove 'from' from local storage if not present
          this.storage.removeItem('from_base');
          this.storage.removeItem('from_last');
        }

        console.log('Retrieved Token:', this.token); // Log the token value

        if (this.token) {
          this.login(this.token);
        } else {
          this.storage.clear();
          this.authService.logout();
          if (this.from) {
            this.storage.setItem('from', this.from); // Store 'from' in local storage
            let decodedFrom = decodeURIComponent(this.from);
            // Remove trailing slash if present
            if (decodedFrom.endsWith('/')) {
              decodedFrom = decodedFrom.slice(0, -1);
            }
            let baseUrl = '';
            let fromLast = '';
            try {
              let urlObj = new URL(decodedFrom);
              baseUrl = urlObj.origin;
              // from_last is everything after the base (pathname without leading slash)
            let path = urlObj.pathname.replace(/^\//, '');
        fromLast = path + urlObj.search;
            } catch (e) {
              // fallback for relative URLs
            // Fallback for raw relative paths (e.g., /create-task?step=5)
        // Clean out any leading slash first to keep slicing uniform
        let cleanRelative = decodedFrom.replace(/^\//, '');
        let firstSlashIdx = cleanRelative.indexOf('/');

        if (firstSlashIdx !== -1) {
          baseUrl = cleanRelative.substring(0, firstSlashIdx);
          fromLast = cleanRelative.substring(firstSlashIdx + 1);
        } else {
          baseUrl = '';
          fromLast = cleanRelative;
        }
            }
            this.storage.setItem('from_base', baseUrl);
            this.storage.setItem('from_last', fromLast);
          }

          if (this.to) {
            this.storage.setItem('redirectTo', `/${this.to}`);
          } else {
            this.storage.removeItem('redirectTo');
          }

          // Not authenticated: a link opened from another app must land on
          // login, not on the destination itself.
          this.commonService.navigateTo('/login');
        }
      });

      // this.socialAuthService.authState.subscribe((user) => {
      //   this.storage.setItem('user', user);
      // });
    } catch (error) {}
  }

  togglePwd() {
    this.pwdShow = !this.pwdShow;
    this.passwordType = this.pwdShow ? 'text' : 'password';
    this.eye = this.pwdShow ? 'bi-eye-slash' : 'bi-eye';
  }

  login(data: any) {
    try {
      if (true) {
        this.submitted = true;
        this.authService.autologin(data).subscribe({
          next: (response: any) => {
            this.submitted = false;
            this.form.reset();
            const redirectTo = this.storage.getItem('redirectTo') || '';
            this.commonService.navigateTo(redirectTo);
            this.commonService.showToast('Logged in successfully!', 'success');
          },
          error: (error) => {
            // console.log(error)
            this.commonService.showToast(error.error.message, 'danger');
            this.submitted = false;
          },
          complete: () => {
            this.submitted = false;
          },
        });
      } else {
        this.commonService.showToast('Fill all required fields.', 'danger');
      }
    } catch (error) {
      //alert(JSON.stringify(error));
    }
  }
}
